/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendedReservationsSavingsSummaryResponse {
    getFixupPrototypeFunction() { return RecommendedReservationsSavingsSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendedReservationsSavingsSummaryResponse>): RecommendedReservationsSavingsSummaryResponse {
        let obj = Object.assign(new RecommendedReservationsSavingsSummaryResponse(), model);
        RecommendedReservationsSavingsSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendedReservationsSavingsSummaryResponse>): RecommendedReservationsSavingsSummaryResponse {
        if (!model) return null;
        return RecommendedReservationsSavingsSummaryResponse.newInstance(<RecommendedReservationsSavingsSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendedReservationsSavingsSummaryResponse) {
        if (!obj) return;

        models.RecommendedReservationsSavingsSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendedReservationsSavingsSummaryResponse): boolean {
        Object.setPrototypeOf(obj, RecommendedReservationsSavingsSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendations_count === undefined) {
            this.recommendations_count = 0;
        }
        if (this.potential_cost_saving === undefined) {
            this.potential_cost_saving = 0;
        }
        if (this.total_reservations === undefined) {
            this.total_reservations = 0;
        }
        if (this.potential_current_estimated_cost === undefined) {
            this.potential_current_estimated_cost = 0;
        }
    }

    /**
     * Recommendations Count.
     */
    recommendations_count: number;

    /**
     * Potential Cost Saving.
     */
    potential_cost_saving: number;

    /**
     * Total reservations.
     */
    total_reservations: number;

    /**
     * Potential current estimated cost.
     */
    potential_current_estimated_cost: number;

}
